import React, { Fragment } from 'react';
import Head from 'compat/Head';
import { ThemeProvider } from 'styled-components';
import { theme } from 'common/theme/appCreative';
import ResetCSS from 'common/assets/css/style';
import Sticky from 'react-stickynode';
import Navbar from 'containers/AppCreative/Navbar';
import PagesBanner from 'containers/AppCreative/PagesBanner';
import Experiences from 'containers/AppCreative/Experience';
import CallToAction from 'containers/AppCreative/CallToAction';
import FeatureSlider from 'containers/AppCreative/FeatureSlider';
import Footer from 'containers/AppCreative/Footer';
import GlobalStyle, { AppWrapper, ContentWrapper } from 'containers/AppCreative/appCreative.style';
import bannerImg from 'common/assets/image/appCreative/bannerImg_contact.png';
import ContactUs from 'containers/AppCreative/ContactUs';

export default function AppCreative() {
  return (
    <ThemeProvider theme={theme}>
      <Fragment>
        <Head>
          <title>Contact Us | Linok: From Data to Decisions: Revolutionizing Milk Quality Monitoring</title>
          <link rel="icon" href="/favicon.png" />
          <meta name="description" content="Revolutionizing dairy management with cutting-edge technology, Linok provides real-time data analytics and insights to help farmers make smarter decisions, optimize herd health, boost production efficiency, and achieve sustainable growth" />
          <meta name="theme-color" content="#156b83" />
          <meta name="keywords" content="Linok, dairy, farming, data, sensors" />
        </Head>
        {/* end of head */}
        <ResetCSS />
        <GlobalStyle />
        {/* end of global and reset style */}
        {/* start app creative landing */}
        <AppWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-active">
            <Navbar />
          </Sticky>
          <ContentWrapper>
            <PagesBanner
              title={'Become a Partner'}
              subtitle={'Join Us in Revolutionizing the Dairy Industry: Partner with Linok to Drive Innovation, Enhance Sustainability, and Create a Better Future for Dairy Together'}
              bannerImg={bannerImg}
            />
            <ContactUs reason={'Become a Partner'} />

          </ContentWrapper>
          <Footer />
        </AppWrapper>{' '}
        {/* end of app creative landing */}
      </Fragment>
    </ThemeProvider>
  );
}
